import { FC, useCallback } from 'react';
import { useField } from 'formik';

import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import MuiRadioGroup, {
  RadioGroupProps as MuiRadioGroupProps,
} from '@mui/material/RadioGroup';

export type Option = {
  value: string;
  label: string;
};

type Props = MuiRadioGroupProps & {
  name: string;
  label?: string;
  options: Option[];
};

export type RadioGroupProps = Props;

const RadioGroup: FC<Props> = ({ name, label, options, ...rest }) => {
  const [{ value }, , { setValue }] = useField(name);

  const handleChange = useCallback(
    (value: any) => () => {
      setValue(value);
    },
    [setValue]
  );

  return (
    <FormControl>
      <FormLabel>{label}</FormLabel>

      <MuiRadioGroup {...rest}>
        {options.map((option, key) => (
          <FormControlLabel
            {...option}
            key={key}
            control={<Radio checked={value === option.value} />}
            onChange={handleChange(option.value)}
          />
        ))}
      </MuiRadioGroup>
    </FormControl>
  );
};

export default RadioGroup;
